import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { DeleteUserModel } from 'src/app/viewModels/users/UserListModel';
import { UserService } from '../../services/user/user.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { PaginationViewModel } from 'src/app/viewModels/permissions/paginationViewModel/pagination-view-model';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { CreateUserComponent } from '../createUser/create-user.component';
import { EditUserComponent } from '../editUser/edit-user.component';
import { clickableColumns } from 'src/app/middleware/common/clickableColumns';
import { downloadableListAsDisplayedColumns } from 'src/app/middleware/common/table/table.component';
import { ExcelServicesService } from 'src/app/middleware/common/excel-services.service';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { CommonService } from 'src/app/middleware/common/common.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserListComponent implements OnInit, AfterViewInit {
  showBadge: number = 5;
  userData: any[] = [];
  displayedColumns = [
    'FirstName',
    'LastName',
    'Email',
    'RegisterDate',
    'Status',
    'Roles',
    'Action',
  ];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Input()
  result = '';
  isEdit = false;
  deleteUser: DeleteUserModel = new DeleteUserModel();
  userListResponseHolder: any;
  deleteUserResponseHolder: any;
  clickEventsubscription: Subscription;
  clickEventsubscriptionForSearch:Subscription;
  presistantUserData: any[] = [];
  currentData: any;
  showEdit: boolean = false;
  showAdd: boolean = false;
  showDelete: boolean = false;

  targetList: any = [];
  sendDisplayedColumns: string[] = [];
  showColumnNames: string[] = [];
  clickableColumns: clickableColumns[] = [];
  permissions: any[] = [];

  showcreateForm: Boolean = false;
  showSidePanel: boolean = false;
  showeditForm: boolean = false;
  getUserListModel = {
    pageSize: 10,
    pageIndex: 1,
    databaseID: 0,
    organizationID: 0,
    SearchKey:""
  };

  // targetList: any = [];
  // sendDisplayedColumns: string[] = ['firstName', 'lastName', 'email', 'registerDateDt', 'isActive', 'userRole', 'Edit', 'Delete'];  // this is being used in child component $$...
  // showColumnNames: string[] = ['First Name', 'Last Name', 'Email', 'Register Date', 'Status', 'Roles', 'Edit', 'Delete'];  // this is being used if child component will show lable with different names $$...
  // clickableColumns: clickableColumns[] = [{ column: 'Edit', icon: 'edit', function: 'openEditDialog' }, {
  //   column: 'Delete', icon: 'delete', function: 'deleteUserDialog'
  // }];
  totalCount: number;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    SearchKey:" ",
    databaseID: 0,
    organizationID: 0
  };

  pageIndex: any;
  pageSize: any;
  value = '';
  Module:string;
  
  constructor(private dialog: MatDialog, private userService: UserService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private pagination: PaginationViewModel, private commonService: CommonService,
    private _dataSharingService: DataSharingService, private constant: Constants, private statusConst: StatusConstant,
    private excelService: ExcelServicesService,private loaderService: LoaderService,private toastr: ToastrService) {
    this.getUserListModel.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getUserListModel.organizationID = parseInt(sessionStorage.getItem('organizationID'));
    this.permissions = JSON.parse(sessionStorage.getItem('permissions'));
    this.permissions.forEach((element) => {
      this.constant.routeArray.forEach((route) => {
        if (element.moduleRoute == route.userRoute) {
          if (element.isAddPermission == true) {
            this.showAdd = true;
          }
          if (element.isDeletePermission == true) {
            this.showDelete = true;
          }
          if (element.isEditPermission == true) {
            this.showEdit = true;
          }
        }
      });
    });

    if (this.showEdit == true && this.showDelete == true) {
      this.sendDisplayedColumns = [
        'firstName',
        'lastName',
        'email',
        'registerDateDt',
        'isActive',
        'userRole',
        'Edit',
        'Delete',
      ];
      this.showColumnNames = [
        'First Name',
        'Last Name',
        'Email',
        'Register Date',
        'Status',
        'Roles',
        'Edit',
        'Delete',
      ];
      this.clickableColumns = [
        { column: 'Edit', icon: 'edit', function: 'openEditDialog' },
        {
          column: 'Delete',
          icon: 'delete',
          function: 'deleteUserDialog',
        },
      ];
    } else if (this.showEdit == true && this.showDelete == false) {
      this.sendDisplayedColumns = [
        'firstName',
        'lastName',
        'email',
        'registerDateDt',
        'isActive',
        'userRole',
        'Edit',
      ]; // this is being used in child component $$...
      this.showColumnNames = [
        'First Name',
        'Last Name',
        'Email',
        'Register Date',
        'Status',
        'Roles',
        'Edit',
      ]; // this is being used if child component will show lable with different names $$...
      this.clickableColumns = [
        { column: 'Edit', icon: 'edit', function: 'openEditDialog' },
      ];
    } else if (this.showEdit == false && this.showDelete == true) {
      this.sendDisplayedColumns = [
        'firstName',
        'lastName',
        'email',
        'registerDateDt',
        'isActive',
        'userRole',
        'Delete',
      ];
      this.showColumnNames = [
        'First Name',
        'Last Name',
        'Email',
        'Register Date',
        'Status',
        'Roles',
        'Delete',
      ];
      this.clickableColumns = [
        { column: 'Delete', icon: 'delete', function: 'deleteUserDialog' },
      ];
    } else {
      this.sendDisplayedColumns = [
        'firstName',
        'lastName',
        'email',
        'registerDateDt',
        'isActive',
        'userRole',
      ]; // this is being used in child component $$...
      this.showColumnNames = [
        'First Name',
        'Last Name',
        'Email',
        'Register Date',
        'Status',
        'Roles',
      ]; // this is being used if child component will show lable with different names $$...
      this.clickableColumns = [];
    }
  }

  ngOnInit(): void {
    //sessionStorage.setItem('HeaderModuleName', "User");
    // this.pagination.pageIndex = 1;
    // this.pagination.pageSize = 10;
    this.clickEventsubscriptionForSearch = this._dataSharingService.getSearchValueForUser().subscribe((result) => {
      this.Search(result);       
    });
    this.Module="User";

    // if (!sessionStorage.getItem('foo')) {
    //   sessionStorage.setItem('foo', 'no reload');
    //   location.reload();
    // } else {
    //   sessionStorage.removeItem('foo');
    // }

    this.clickEventsubscription = this._dataSharingService.getClickEvent().subscribe(() => {
        this.getUserList(this.pageModelData);
      });
  
  }

  ngOnDestroy(){
    this.clickEventsubscriptionForSearch.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.getUserList(this.pageModelData);
      this.clickEventsubscription = this._dataSharingService.getSearchValue().subscribe((result) => {
        if (result !== '') {
          this.searchData(result);
        }
      });
    }, 1);
  }

  async getUserList(pageData: any) {
    this.loaderService.show();    
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.SearchKey = pageData.SearchKey.trim();
    this.pageModelData.databaseID = this.getUserListModel.databaseID;
    this.pageModelData.organizationID = this.getUserListModel.organizationID;
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    const result = await this.userService.getUserList(this.pageModelData).toPromise();    
    this.userListResponseHolder = result.data.userModel;
    this.userListResponseHolder.NewPropertyName = 'tempUserRole';  
    if (200 === this.statusConst.statusSuccess){
      this.userListResponseHolder.map((res) => {
        if (res.email != null) {
          res.email = this.encryptionAlgo.get(
            this.reusableClass.decryptionKey,
            res.email
          );
        }
        if (res.userName != null) {
          res.userName = this.encryptionAlgo.get(
            this.reusableClass.decryptionKey,
            res.userName
          );
        }
        if (res.firstName != null) {
          res.firstName = this.encryptionAlgo.get(
            this.reusableClass.decryptionKey,
            res.firstName
          );
        }
        if (res.lastName != null) {
          res.lastName = this.encryptionAlgo.get(
            this.reusableClass.decryptionKey,
            res.lastName
          );
        }
        if (res.phoneNumber != null) {
          res.phoneNumber = this.encryptionAlgo.get(
            this.reusableClass.decryptionKey,
            res.phoneNumber
          );
        }
        res.tempUserRole = res.userRole;
        if (res.userRole != null) {
          res.userRole = res.userRole.replace(/,/g, ', ');
        }
        res.isActive = res.isActive === true ? 'Active' : 'In-Active';
        return res;
      });     
      this.userData = result.data.userModel;//this.userListResponseHolder.data;     
      this.totalCount = result.data.totalCount; //this.userData[0].totalCount;
      this.presistantUserData = this.userListResponseHolder.data; // copy of the data for filteration
      this.pageModelData.pageIndex = result.data.pageIndex;
      this.pageIndex = result.data.pageIndex;
      this.pageSize = pageData.pageSize;
      this.loaderService.hide(); 

    } else {
      this.loaderService.hide();     
    }
  }

  // Search data in User grid
  searchData(filterValue) {
    if (filterValue === '0') {
      this.userData = this.presistantUserData;
    } else {
      this.userData = this.presistantUserData.filter(
        (x) =>
          x.firstName.includes(filterValue) ||
          x.lastName.includes(filterValue) ||
          x.email.includes(filterValue) ||
          x.registerDate.includes(filterValue) ||
          x.userRole.includes(filterValue)
      );
    }
  }

  openEditDialogData(values) {
    let userData = values.data;
    if (values.function == 'openEditDialog') {
      this.openEditDialog(true, userData);
    } else {
      this.deleteUserDialog(values.data);
    }
  }

  closeSidePanel(event) {
    this.showSidePanel = false;
    this.showeditForm = false;
    if (event == true) {
      this.getUserList(this.pageModelData);
    }
  }

  // Open Edit dialog box for Edit User
  openEditDialog(editable: boolean, user: any) {
    this.isEdit = editable;
    let dataarr = [];
    dataarr.push(this.isEdit);
    dataarr.push(user);
    this.commonService.setEditData(dataarr);
    this.showcreateForm = false;
    this.showeditForm = true;
    this.showSidePanel = true;    
  }

  // open dialog box for deleting selected user
  deleteUserDialog(data): void {
    const message = `Are you sure you want to delete this user account?`;   
    let deleteUser = [];
    deleteUser.push(data.uuid);
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });

    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
         
          const result = await this.userService
            .deleteUser(deleteUser)
            .toPromise();
          this.deleteUserResponseHolder = result;
          this.loaderService.hide();
          this.toastr.success('Deleted successfully.', '', {
            timeOut: 3000,
          });
          this._dataSharingService.sendClickEvent();
          return result;
        } else {
          this.loaderService.hide();
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  addUsers() {   
    this.showcreateForm = true;
    this.showSidePanel = true;
    this.showeditForm = false;

    this._dataSharingService.sendAddUserEvent();
  }

  exportAsXLSX(): void {
    //this.pageModelData.pageIndex = 1;
    //this.pageModelData.pageSize = this.totalCount;
    // this.service.getSubDataSourceDetails(this.paramObj).subscribe((res: any) => {
    //   if (res.hasOwnProperty('subDataSourceList')) {
    //     if (res.subDataSourceList.length > 0) {

    // let exportList: any[] = downloadableListAsDisplayedColumns(res.subDataSourceList, this.sendDisplayedColumns, this.clickableColumns, this.showColumnNames);
    // this.excelService.exportAsExcelFile(exportList, 'ManageSubDataSourceList');
    //     }
    //   }
    // });
    //this.pagination = this.pageModelData;
    this.getUserListModel.pageIndex = 0;
    this.getUserListModel.pageSize = this.totalCount;
    this.userService
      .getUserList(this.getUserListModel)
      .subscribe((response) => {
        if (response != undefined) {
          this.userListResponseHolder = response;
          if (
            this.userListResponseHolder.status ===
            this.statusConst.statusSuccess
          ) {
            this.userListResponseHolder.data.userModel.map((res) => {
              (res.email = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey,
                res.email
              )),
                (res.userName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey,
                  res.userName
                ));
              (res.firstName = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey,
                res.firstName
              )),
                (res.lastName = this.encryptionAlgo.get(
                  this.reusableClass.decryptionKey,
                  res.lastName
                ));
              res.phoneNumber = this.encryptionAlgo.get(
                this.reusableClass.decryptionKey,
                res.phoneNumber
              );
              res.isActive = res.isActive === true ? 'Active' : 'In-Active';
              return res;
            });
            let _userData = this.userListResponseHolder.data.userModel;
            this.presistantUserData = this.userListResponseHolder.data.userModel; // copy of the data for filteration
            let exportList: any[] = downloadableListAsDisplayedColumns(
              _userData,
              this.sendDisplayedColumns,
              this.clickableColumns,
              this.showColumnNames
            );
            this.excelService.exportAsExcelFile(exportList, 'UserList');
          } else {
            this.loaderService.hide();
          }
        }
      });
  }

  CallNextPrevPageData(pageData) {    
    this.currentData = pageData;
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.SearchKey = this.value.trim();
    this.getUserList(this.pageModelData);
  }

  // CallNextPrevPageData(pageData) {
  //   this.currentData = pageData;
  //   this.pageModelData.pageIndex = pageData.pageIndex;
  //   this.pageModelData.pageSize = pageData.pageSize;
  //   this.pagination.pageIndex = pageData.pageIndex;
  //   this.pagination.pageIndex = pageData.pageSize;
  //   this.getUserListModel.pageIndex = pageData.pageIndex;
  //   this.getUserListModel.pageSize = pageData.pageSize;
  //   this.getUserList(this.getUserListModel);
  // }

  Search(filterValue) {   
    this.pageModelData.SearchKey = filterValue.trim();
    this.pageModelData.pageIndex = 0;
    this.pageModelData.pageSize = 10;
    this.getUserList(this.pageModelData);
  }

  
}
